import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import _ from "lodash";
import { rootReducersState } from "../../reducers";
import SocialLoginReuireModal from "./SocialLoginReuireModal";

const isBlank = (v: any) =>
  v === null ||
  v === undefined ||
  String(v).trim().length === 0 ||
  String(v).trim().toLowerCase() === "null";

// return true when any required field (first_name, contact_info, gender) is missing
const isProfileIncomplete = (u: any) => {
  if (!u) return true;
  const firstName = _.get(u, "first_name", "");
  const contact = _.get(u, "contact_info", "");
  const gender = _.get(u, "gender", "");
  return isBlank(firstName) || isBlank(contact) || isBlank(gender);
};
const BasicRequireInfo: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const token = useSelector((state: rootReducersState) => state.session.token);
  const user  = useSelector((state: rootReducersState) => state.session.currentUser);

  const [open, setOpen] = useState(false);
const mustBlock = useMemo(() => isProfileIncomplete(user), [user]);
 
  useEffect(() => {
      if (token && mustBlock) setOpen(true);
    else setOpen(false);
  }, [token, mustBlock]);

  return (
    <>
      {open && (
        <SocialLoginReuireModal
          open={open}
          onClose={() => setOpen(false)}
          blocking={true}
        />
      )}
      {children}
    </>
  );
};

export default BasicRequireInfo;
